import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginUserModel } from '../../../models/user.model';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthService
  ) {
    this.createForm();
  }
  // Variables
  public loginForm: FormGroup;
  private routeSubscription: Subscription;
  public successMessage = '';
  public redirectUrl = '/home';
  public showPassword = false;
  public errorMessage = '';
  public notVerified = false;

  public ngOnInit() {
    this.routeSubscription = this.activatedRoute.queryParams.subscribe(
      params => {
        const verified = params['verified'];
        if (verified === 'true') {
          this.successMessage =
            'Deine E-Mail Adresse wurde erfolgreich bestätigt. Du kannst dich jetzt einloggen.';
        }
        const reset = params['reset'];
        if (reset === 'true') {
          this.successMessage =
            'Dein Passwort wurde erfolgreich zurückgesetzt. Du kannst dich jetzt einloggen.';
        }
        const redirectUrl = params['redirectUrl'];
        if (redirectUrl) {
          this.redirectUrl = decodeURIComponent(redirectUrl);
        }
      }
    );
  }

  public login() {
    if (!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      console.error('Form not valid');
      return;
    }
    const logInUser: LoginUserModel = {
      email: this.loginForm.value.email?.trim(),
      password: this.loginForm.value.password?.trim(),
    };
    this.authService
      .login(logInUser)
      .then(() => {
        const [path, queryString] = this.redirectUrl.split('?');
        const queryParams = {
          ...this.parseQueryParams(queryString),
        };
        this.router.navigate([path], { queryParams });
      })
      .catch(error => {
        if (error.message === 'User not verified') {
          this.notVerified = true;
          this.errorMessage =
            'Deine E-Mail Adresse wurde noch nicht verifiziert. Bitte überprüfe dein E-Mail-Postfach oder sende die Verifizierungs-Mail erneut.';
        } else {
          this.loginForm.get('email').setErrors({ incorrect: true });
          this.loginForm.get('password').setErrors({ incorrect: true });
        }
      });
  }

  private parseQueryParams(queryString: string): { [key: string]: string } {
    if (!queryString) {
      return {};
    }
    return queryString.split('&').reduce((acc, param) => {
      const [key, value] = param.split('=');
      acc[decodeURIComponent(key)] = decodeURIComponent(value);
      return acc;
    }, {});
  }

  public removeErrors(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      return;
    }
    this.loginForm.get('email').setErrors(null);
    this.loginForm.get('password').setErrors(null);
  }

  public route(route: string) {
    this.router.navigate([route]);
  }

  public togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  public createForm() {
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required),
    });
  }

  public resendVerificationEmail() {
    this.authService
      .resendVerificationEmail(this.loginForm.value.email)
      .then(() => {
        this.notVerified = false;
        this.errorMessage = '';
        this.successMessage =
          'Die Verifizierungs-Mail wurde erfolgreich gesendet.';
        this.router.navigate(['/verify']);
      })
      .catch(error => {
        // handle error
      });
  }

  public ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }
}
